









































import { Component, Prop, Vue } from 'vue-property-decorator';

import InfoIcon from '@/components/icons/Info.vue';

import {
  EInitiativesDictionary,
  resolveInitiativeThemeStyle
} from '@/models/initiatives';

type Size = 'sm' | 'md';

@Component({
  components: {
    InfoIcon
  }
})
export default class FilterTag extends Vue {
  @Prop(String) label!: string;
  @Prop({ default: 'button' }) as?: string;
  @Prop({ default: false }) isActive?: boolean;
  @Prop({ default: EInitiativesDictionary.DEFAULT })
  theme?: EInitiativesDictionary;
  @Prop({ default: 'md' }) size?: Size;
  @Prop({ default: false }) viewOnly?: boolean;
  @Prop({ default: false }) unmargin?: boolean;
  @Prop({ default: '' }) tooltipText?: string;

  get themeStyle() {
    return resolveInitiativeThemeStyle(this.theme);
  }
}
